import { useState } from "react";
import Hero from "../components/Destination/Hero";
import DestinationCollection from "../components/Destination/DestinationCollections";
import CTA from "../components/Destination/CTA";
import type { DestinationBrowseFilters } from "../components/Destination/destinationBrowseFilters";

function Destination() {
  const [filters, setFilters] = useState<DestinationBrowseFilters>({
    tab: "All",
    region: "All Regions",
    travelType: "All Types",
    season: "Any Season",
  });

  return (
    <>
      <Hero filters={filters} onFiltersChange={setFilters} />
      <DestinationCollection filters={filters} />
      <CTA />
    </>
  );
}

export default Destination;
